import React, { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Network from "../../../modules/network";
import { getLibraryListRoute } from "../../routes";

type Props = {}

const Container = styled.div`
    padding: 1em;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    border-bottom: 1px solid black;

    .info {
        padding: .5em;
        flex: 0 0 48%;

        p {
            margin-bottom: .5em;
        }

        li {
            list-style-position: inside;
            padding-left: 2em;
        }
    }

    form {
        flex: 0 0 48%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;



        textarea {
            width: 100%;
            min-height: 40vh;
            margin: 0 auto 1em;
            padding: .5em;
        }
    }

    .add-dialog {
        background: rgba(0,0,0,.8);
        position: fixed;
        z-index: 10;

        top: 0;
        left: 0;
        height: 100vh;
        width: 100vw;

        display: flex;
        justify-content: center;
        align-items: center;

        h2 {
            padding: .5em 0;
        }

        .container {
            width: 95vw;
            height: 95vh;

            background: white;

            display: flex;
            flex-direction: column;

            overflow-y: auto;
        }

        .codes-list {
            width: 90%;
            margin: 1em auto;

            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            justify-content: space-between;
        }

        .code {
            width: 20%;
            padding: 1em;
            margin: .5em 0;
            border: 1px solid black;
            border-radius: 0.5em;

            display: flex;
            justify-content: center;
            align-items: center;
        }

        .buttons {
            display: flex;
            flex-direction: row;

            justify-content: center;
            align-items: center;

            padding: 2em 0;

            button {
                margin: 0 1em;
            }
        }

        .success {
            color: green;
            text-align: center;
            padding: 2em 0;

            p {
                margin: .5em;
            }
        }

        .error {
            color: red;
            text-align: center;
            padding: 2em 0;

            p {
                margin: .5em;
            }
        }
    }

`;

const MultiCodeAddForm: React.FC<Props> = () => {

    const { register, handleSubmit } = useForm();

    const [findedCodes, setFindedCodes] = useState<string[]>([]);
    const [showPopup, setShowPopup] = useState(false);

    const onSubmit = useCallback((data: { codes: string }) => {
        const re = /(?:;|$|,|\n)/;
        const codes = data.codes
            .split(re)
            .filter(Boolean)
            .map(s => s.trim());

        setFindedCodes(codes);
        setShowPopup(true);
    }, [setFindedCodes]);

    const { mutate, isSuccess, isError, isIdle } = useMutation(Network.addMultipleLibrary);

    const onSendClick = useCallback(() => {
        mutate({codes: findedCodes});
    }, [mutate, findedCodes]);

    return <Container>
        <form onSubmit={handleSubmit(onSubmit)}>
            <textarea placeholder="Lista kodów..." {...register('codes')}></textarea>
            <button>Wyślij</button>
        </form>
        <div className="info">
            <p>Proszę podać listę kodów bibliotek które należy wprowadzić do bazy danych.</p>
            <p>Duszczalne separatory:</p>
            <ul>
                <li>nowa linia</li>
                <li>przecinek: ,</li>
                <li>średnik: ;</li>
            </ul>
        </div>

        {showPopup && <div className="add-dialog">
            <div className="container">
                <h2>Zostały podane następujące kody</h2>
                <div className="codes-list">
                    {
                        findedCodes.map(code => {
                            return <div key={code} className='code'>{code}</div>
                        })
                    }
                </div>

                {isSuccess && <div className="success">
                    <p>Kody dodane</p>
                    <Link to={getLibraryListRoute()}>Przejdź do listy bibliotek</Link>
                </div> }
                {isError && <div className="error">
                    <p>Coś poszło nie tak</p>
                </div> }

                {isIdle &&<div className="buttons">
                    <button onClick={() => setShowPopup(false)}>Anuluj</button>
                    <button onClick={onSendClick}>Dodaj do bazy danych</button>
                </div>}
            </div>
        </div>}
    </Container >
}

export default MultiCodeAddForm;
